var map = {
	"./cursor.png": 4173,
	"./icons/account.svg": 652,
	"./icons/android-chrome-192x192.png": 9000,
	"./icons/android-chrome-512x512.png": 3244,
	"./icons/android-chrome-maskable-192x192.png": 6527,
	"./icons/android-chrome-maskable-512x512.png": 4472,
	"./icons/apple-touch-icon-120x120.png": 2269,
	"./icons/apple-touch-icon-152x152.png": 9071,
	"./icons/apple-touch-icon-180x180.png": 6478,
	"./icons/apple-touch-icon-60x60.png": 2250,
	"./icons/apple-touch-icon-76x76.png": 3302,
	"./icons/apple-touch-icon.png": 654,
	"./icons/base_metabolism.svg": 3867,
	"./icons/bmi.svg": 8219,
	"./icons/body-type.svg": 2066,
	"./icons/body_type.svg": 2586,
	"./icons/cart.svg": 4467,
	"./icons/common_risk_level.svg": 1111,
	"./icons/eye-hide.svg": 2777,
	"./icons/eye.svg": 9947,
	"./icons/fat_percent.svg": 9665,
	"./icons/globe.svg": 1909,
	"./icons/ideal_weight.svg": 4365,
	"./icons/long-arrow.svg": 9972,
	"./icons/obesity_level.svg": 2890,
	"./icons/passport_age.svg": 7070,
	"./icons/safari-pinned-tab.svg": 4980,
	"./icons/tailless-arrow.svg": 5258,
	"./icons/threedots.svg": 207,
	"./icons/waist_to_hip_proportion.svg": 550,
	"./report-analysis.png": 9227,
	"./social-icons/facebook.png": 5805,
	"./social-icons/facebook.svg": 5202,
	"./social-icons/google.png": 2646,
	"./social-icons/habr.jpg": 8035,
	"./social-icons/instagram.png": 7621,
	"./social-icons/instagram.svg": 5891,
	"./social-icons/linked_in.svg": 2293,
	"./social-icons/linkedin.svg": 9626,
	"./social-icons/telegram.png": 8608,
	"./social-icons/telegram.svg": 5133,
	"./social-icons/twitter.png": 7436,
	"./social-icons/twitter.svg": 6405,
	"./stars.webp": 5712,
	"./svg/404.svg": 461,
	"./svg/ai_icon.svg": 483,
	"./svg/ai_icon_hover.svg": 7156,
	"./svg/app-store.svg": 214,
	"./svg/apple.svg": 8246,
	"./svg/arrow_down.svg": 5660,
	"./svg/arrow_next.svg": 3510,
	"./svg/asterisk_icon.svg": 4653,
	"./svg/asterisk_icon_hover.svg": 1880,
	"./svg/back_pattern.svg": 222,
	"./svg/back_pattern2.svg": 985,
	"./svg/background_pattern.svg": 6081,
	"./svg/books.svg": 417,
	"./svg/chevron_down.svg": 2145,
	"./svg/chevron_right.svg": 1740,
	"./svg/close-icon.svg": 4402,
	"./svg/cursor.svg": 7592,
	"./svg/data_text.svg": 1904,
	"./svg/devices-icon.svg": 5776,
	"./svg/devices-icon_hover.svg": 6383,
	"./svg/dots.svg": 5696,
	"./svg/dots_around_card.svg": 1774,
	"./svg/dots_around_card_vertical.svg": 3999,
	"./svg/dots_back.svg": 3199,
	"./svg/dots_gray_vertical.svg": 9774,
	"./svg/envelope.svg": 2295,
	"./svg/flags/EN.svg": 1314,
	"./svg/flags/IE.svg": 8130,
	"./svg/flags/RU.svg": 7662,
	"./svg/flags/UA.svg": 5588,
	"./svg/flags/UK.svg": 2388,
	"./svg/flags/US.svg": 6568,
	"./svg/google-play.svg": 4638,
	"./svg/google.svg": 5075,
	"./svg/hdots.svg": 1682,
	"./svg/hoverme-icon.svg": 1088,
	"./svg/link-out-white.svg": 8100,
	"./svg/link-out.svg": 5872,
	"./svg/logo.svg": 5222,
	"./svg/menu-icon.svg": 5185,
	"./svg/partners/garmin-connect.svg": 5537,
	"./svg/partners/huawei.svg": 7453,
	"./svg/partners/mi-fit.svg": 9717,
	"./svg/partners/mi-home.svg": 85,
	"./svg/partners/pedometer.svg": 5361,
	"./svg/partners/samsung-health.svg": 8064,
	"./svg/rating-star.svg": 7753,
	"./svg/scroll_icon.svg": 7416,
	"./svg/star-disabled.svg": 1620,
	"./svg/star.svg": 6410,
	"./svg/uk_flag.svg": 4713,
	"./svg/waves.svg": 2410,
	"./team1.png": 7319,
	"./team2.png": 6158,
	"./team3.png": 2471,
	"./team4.png": 7721,
	"./testscreen.png": 7058,
	"./testscreen0.png": 2558,
	"./testscreen1.png": 7545,
	"./testscreen2.png": 8520,
	"./third-part/HIPAA.png": 7675,
	"./third-part/crunchbase.png": 9597,
	"./third-part/f6s-follow-white.png": 1168,
	"./third-part/gust.png": 575,
	"./thumbnails/th1.jpg": 4403,
	"./thumbnails/th1.png": 8998,
	"./thumbnails/th2.jpg": 5239,
	"./thumbnails/th3.jpg": 3830,
	"./thumbnails/th4.jpg": 7122,
	"./thumbnails/th5.jpg": 7009,
	"./thumbnails/th6.jpg": 6605,
	"./thumbnails/th7.jpg": 2057,
	"./thumbnails/th8.jpg": 4154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;